/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DepartmentSubjectKatuzeLvAcreageDto } from './departmentSubjectKatuzeLvAcreageDto.model';


export interface SubjectKatuzeLvAcreageDto { 
    acreageForeignFbM2?: number;
    acreageMyFbM2?: number;
    acreageOutsideFbM2?: number;
    departmentSubjectKatuzeLvAcreageList?: Array<DepartmentSubjectKatuzeLvAcreageDto>;
    katuzeKod?: number;
    katuzeNazev?: string;
    lv?: number;
    notRentedAcreage?: number;
    opsubId?: number;
    portion?: string;
    rentedAcreage?: number;
    typravKod?: string;
    typravNazev?: string;
}

